<div class="row" *ngIf="summary && tables && tables.length > 0">
    <div class="col-md-12 summery-tables">
        <h5 [ngClass]="cssClass">{{ title }}</h5>
    </div>
    <div class="col-md-12" *ngFor="let table of tables; let i = index;">
        <label>{{ table.header }}</label>:&nbsp;<label class="bold">{{ table.items.slice(-1)[0].value }} <ng-container *ngIf="table.items.slice(-1)[0].timeframe">({{ table.items.slice(-1)[0].timeframe }})</ng-container></label>
    </div>
</div>

<div class="row not-summary" *ngIf="!summary">
    <div class="col-md-12" [ngClass]="table.items.length <= 10 ? 'mb-3' : ''" *ngFor="let table of tables; let i = index;">
        <ng-container *ngIf="table.items.length <= 10">
            <div class="layout-table indicators" *ngIf="table.header || table.class || table.type">
                <div class="layout-table-header">
                    <div class="layout-table-header-item bold">
                        <h6 [ngClass]="cssClass">{{ table.header || "" }}<label class="subheader" *ngIf="table.class && table.type">&nbsp;[{{ table.class + " - " + (table.type?.label || table.type?.value) }}]</label></h6>
                    </div>
                </div>
            </div>
            <ng-container *ngTemplateOutlet="indicatorsTable; context: { table: table }"></ng-container>
        </ng-container>
        <ng-container *ngIf="table.items.length > 10">
            <div class="accordion " id="fiIndicators{{ i }}Accordion">
                <div class="accordion-item">
                    <div class="accordion-header" id="headingfiIndicators{{ i }}Accordion1">
                        <h2 class="mb-0">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse" attr.data-bs-target="{{'#fiIndicators' + i + 'accmultiple1'}}" aria-expanded="false"
                            attr.aria-controls="{{'collapsefiIndicators' + i + 'accmultiple'}}"><h6 [ngClass]="cssClass">{{ table.header }}<label class="subheader" *ngIf="table.class && table.type">&nbsp;[{{ table.class + " - " + (table.type?.label || table.type?.value) }}]</label></h6></button>
                        </h2>
                    </div>
                    <div id="fiIndicators{{ i }}accmultiple1" class="accordion-collapse collapse" attr.aria-labelledby="{{'headingfiIndicators' + i + 'Accordion1'}}" attr.data-bs-parent="{{'#fiIndicators' + i + 'Accordion'}}">
                        <div class="accordion-body">
                            <ng-container *ngTemplateOutlet="indicatorsTable; context: { table: table }"></ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="col-md-12">
        <ng-container *ngFor="let item of list">
            <h6 class="fishery-section">{{ item.type?.value ? item.type.value : item.type }}</h6>
            <fi-template-renderer [template]="item.text"></fi-template-renderer>
        </ng-container>
    </div>
</div>

<ng-template #indicatorsTable let-table="table">
    <div class="layout-table indicators">
        <div class="layout-table-header">
            <div class="layout-table-header-item">
                <label class="text-color-gray-dark bold">{{ dynamicFormControlService.getGenericProperty(collectionForm,"fisheryindicator.measure","label") }}</label>
            </div>
            <div class="layout-table-header-item">
                <label class="text-color-gray-dark bold">{{ dynamicFormControlService.getGenericProperty(collectionForm,"fisheryindicator.value","label") }}</label>
            </div>
            <div class="layout-table-header-item">
                <label class="text-color-gray-dark bold">{{ dynamicFormControlService.getGenericProperty(collectionForm,"fisheryindicator.unit","label") }}</label>
            </div>
            <div class="layout-table-header-item">
                <label class="text-color-gray-dark bold">{{ dynamicFormControlService.getGenericProperty(collectionForm,"fisheryindicator.timeframe","label") }}</label>
            </div>
            <div class="layout-table-header-item" *ngIf="showIndicatorText(table)">
                <label class="text-color-gray-dark bold">{{ dynamicFormControlService.getGenericProperty(collectionForm,"fisheryindicator.indicatorText","label") }}</label>
            </div>
            <div class="layout-table-header-item" *ngIf="showTargetSpecies(table)">
                <label class="text-color-gray-dark bold">{{ dynamicFormControlService.getGenericProperty(collectionForm,"fisheryindicator.targetSpecies","label") }}</label>
            </div>
        </div>
        <div class="layout-table-body">
            <div class="layout-table-row" id="fisheryindicator_{{i}}" *ngFor="let fisheryindicator of table.items;let i = index">
                <div class="layout-table-cell">
                    <div class="data-item-value"><span innerHTML="{{ fisheryindicator?.measure?.label || fisheryindicator?.measure?.value || fisheryindicator?.freemeasure || '-' }}"></span></div>
                </div>
                <div class="layout-table-cell align-right">
                    <div class="data-item-value number">{{ decimalFormat(fisheryindicator?.value) || "-" }}</div>
                </div>
                <div class="layout-table-cell">
                    <div class="data-item-value">{{ fisheryindicator?.unit || "-" }}</div>
                </div>
                <div class="layout-table-cell">
                    <div class="data-item-value">{{ fisheryindicator?.timeframe || "-" }}</div>
                </div>
                <div class="layout-table-cell" *ngIf="showIndicatorText(table)">
                    <div class="data-item-value"><span [textContent]="fisheryindicator?.indicatorText"></span></div>
                </div>
                <div class="layout-table-cell" *ngIf="showTargetSpecies(table)">
                    <div class="data-item-value">{{ fisheryindicator?.targetSpecies?.label || fisheryindicator?.targetSpecies?.value || "-" }}</div>
                </div>
            </div>
        </div>
    </div>
</ng-template>